import React, { useCallback, useEffect } from 'react'
import API from '../../../../services/api'
import EventsTable from './EventsTable'
import useAPIRequest from '../../../../hooks/useAPIRequest'
import Container from '../../../atoms/page/Page'
import LoadingSpinner from '../../../atoms/loadingspinner/LoadingSpinner'
import Banner from '../../../atoms/banner/Banner'

function OpenEvents () {
  const callback = useCallback(() => {
    return API.getOpenEvents()
  }, [])

  const [{ inProgress, data, completed, error }, doAPIRequest] = useAPIRequest<API.EventResponseSummary[]>(callback, { data: [] })

  useEffect(() => {
    doAPIRequest()
  }, [doAPIRequest])

  const handleRefreshEvent = useCallback(() => {
    doAPIRequest()
  }, [doAPIRequest])

  return (
    <Container>
      {inProgress && <LoadingSpinner />}
      {error && <Banner type='error' active={!!error} message={error?.message} />}
      {completed && data && <EventsTable events={data} refreshEvents={handleRefreshEvent}/>}
    </Container>
  )
}

export default OpenEvents
